export async function askLogin(path) {
  const redirect = useCookie('redirect', { path: '/' })
  redirect.value = path
  navigateTo('#connexion', { replace: true })
}
